export default __webpack_public_path__ + "static/media/img-tests-purple.564c3883.jpg";